/**
 * Analytics-consent storage for the public marketing site.
 *
 * GDPR posture: analytics is OFF by default. PostHog is not initialised — and
 * therefore no analytics cookie is set — until the visitor explicitly grants
 * consent via the banner. A decision (granted OR denied) is remembered so the
 * banner doesn't re-prompt on every page. See ADR-0077 + the cookie policy.
 */

export type ConsentDecision = 'granted' | 'denied';

const STORAGE_KEY = 'syncanix:analytics-consent';

/** Read the stored decision, or `null` if the visitor hasn't chosen yet. */
export function readConsent(): ConsentDecision | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch {
    // Private-mode / blocked storage → treat as undecided (banner shows, no tracking).
    return null;
  }
}

/** Persist the visitor's decision. */
export function writeConsent(decision: ConsentDecision): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, decision);
  } catch {
    // Non-fatal: if storage is blocked the choice simply isn't remembered.
  }
}
